<template>
  <div id="AboutMeText6" :class="sectionClass">
    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="pink">
        Selected Clients
      </h4>
      <ul>
        <li>The ABC</li>
        <li>Amnesty International</li>
        <li>Australian Super</li>
        <li>BONDs</li>
        <li>Crumpler</li>
        <li>Cartier</li>
        <li>Little Bao Hong Kong</li>
        <li>Heineken</li>
        <li>JD Sports</li>
        <li>Nike</li>
        <li>OPSM</li>
        <li>Platypus Sneakers</li>
        <li>Playstation</li>
        <li>Red Bull</li>
        <li>Reebok</li>
        <li>Seven Seeds Coffee</li>
        <li>Strava</li>
        <li>Süddeutsche Zeitung Magazin</li>
        <li>Swatch</li>
        <li>Swinburne University</li>
        <li>TED Talks</li>
        <li>The Design Files</li>
        <li>The Lifted Brow</li>
        <li>The Loop</li>
        <li>Twitter</li>
        <li>Xero</li>
      </ul>
    </div>

    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="green">Selected Press</h4>
      <ul>
        <li>Swinburne 25 Project</li>
        <li>Australia Super’s Current Influencer</li>
        <li>VICE The Creators Project: Art Scout</li>
        <li>The Design Files: New Kid on the Blog</li>
        <li>The Young Ones Magazine: Featured Creative</li>
        <li>People of Box Hill</li>
        <li>Trouble Juice interview</li>
        <li>Houzz: Creatives at Home</li>
        <li>On Jackson Street: Artist Profile</li>
        <li>The Design Kids: Interview: Nathan Nankervis</li>
        <li>The Design Kids: 15 Designers to Watch in 2015</li>
      </ul>
    </div>

    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="red">Published Work</h4>
      <ul>
        <li>Amnesty International: AM-UNITY Magazine Issue 7</li>
        <li>Semi-Permanent Annual</li>
        <li>Voiceworks Issue 98 ‘Master’</li>
        <li>Hello Mr. Issue 03</li>
        <li>Agideas ‘Look Upstairs’</li>
        <li>The Loop ‘Designer to Watch’</li>
        <li>Frankie Magazine ‘Top Picks’</li>
        <li>Australian Design Biennale</li>
      </ul>
    </div>

    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="yellow">Speaking Engagements</h4>
      <ul>
        <li
          >Le Mana X NRL X Swinburne University Pasifika Youth Workshop (3 days)
          - 2023</li
        >
        <li>Swinburne University Honours Students - 2022</li>
        <li>Albert Park College - 2018</li>
        <li>The Design Kids #TDKTuesday @ General Assembly - 2017</li>
        <li>Australian Graphic Design Association: ‘First Five Out’ – 2015</li>
      </ul>
    </div>

    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="blue">Awards</h4>
      <ul>
        <li>Agideas New Star Finalist – 2015</li>
        <li>Agideas New Star Finalist – 2014</li>
        <li>Australian Design Biennale Student Award – 2012</li>
      </ul>
    </div>

    <div class="uk-text-center uk-margin-xlarge-top white">
      <h4 class="pink">Exhibitions</h4>
      <ul>
        <li>Outre Gallery ‘LOCALS’ Group show - Melbourne, 2024</li>
        <li>Sky Gallery Group Show - Melbourne, 2023</li>
        <li>SCAPE Artist in Residence - Melbourne, 2023</li>
        <li
          >‘SMILE’- Solo Exhibition @ Lamington Drive Gallery - Melbourne,
          2022</li
        >
        <li
          >Nathan &amp; Friends Present: ‘Lettermen’ - Curated Group Show -
          Melbourne, 2016</li
        >
        <li>TDK:Fourplay – Australia-wide, 2014</li>
        <li>Terra Populi – Amnesty International – Melbourne, 2014</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 5% 0% 20%;
}

.sectionMobile {
  padding: 12% 0% 35%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText6.vue